import { useMutation, useQueryClient } from '@tanstack/react-query';
import { checkinService } from '@services';
import { USER_PROFILE_QUERY_KEY } from './useUserProfile';
import { useAuthStore } from '@app/stores';

export const useCheckIn = () => {
  const queryClient = useQueryClient();
  const validateAndUpdateUser = useAuthStore(
    (state) => state.validateAndUpdateUser
  );

  return useMutation({
    mutationFn: () => checkinService.checkIn(),
    onSuccess: async () => {
      // Refetch
      await queryClient.invalidateQueries({ queryKey: USER_PROFILE_QUERY_KEY });

      // Update auth store
      await validateAndUpdateUser();
    },
  });
};
